module.exports = __webpack_public_path__ + "static/img/zs2.af6780ae.png";